import React, { useMemo } from 'react';
import { Grid, Row, Col, Text } from 'rsuite';
import { PAYMENT_METHODS } from '../../../../common/enums';
import { PaymentMethod } from 'src/types/payment';
import { PaymentMethodButton } from './PaymentMethodButton';

interface ControlledPaymentSelectorProps {
  achEnabled?: boolean;
  ccVerbiage?: string;
  ccEnabled?: boolean;
  checkEnabled?: boolean;
  onSelectPaymentMethod: (method: PaymentMethod) => void;
  paymentMethod?: PaymentMethod;
  singlePaymentButton?: boolean;
}

export const ControlledPaymentMethodSelector = ({
  achEnabled,
  ccEnabled,
  ccVerbiage,
  checkEnabled,
  onSelectPaymentMethod,
  paymentMethod,
  singlePaymentButton,
}: ControlledPaymentSelectorProps) => {
  const multipleEnabled = useMemo(() => {
    // Special case: when singlePaymentButton is true and only CC+ACH are enabled
    if (singlePaymentButton && ccEnabled && achEnabled && !checkEnabled) {
      return false;
    }

    // Normal case: count enabled payment methods
    const enabled = [ccEnabled, achEnabled, checkEnabled].filter(Boolean);

    return enabled.length > 1;
  }, [ccEnabled, achEnabled, checkEnabled, singlePaymentButton]);

  const ccButtonIcon = useMemo(() => {
    const icons = ['/assets/credit-card-icon.svg'];
    if (singlePaymentButton) {
      icons.push('/assets/bank-building-ACH-direct-debit.svg');
    }
    return icons;
  }, [singlePaymentButton]);

  const ccLabel = useMemo(() => {
    if (singlePaymentButton) {
      return 'Credit Card / ACH';
    }
    return ccVerbiage || 'Credit or Debit Card';
  }, [ccVerbiage, singlePaymentButton]);

  return (
    <Grid fluid>
      <Row className="mb-8">
        <Col xs={24}>
          <Text className="text-small text-bold">Payment Method</Text>
        </Col>
      </Row>

      {multipleEnabled && (
        <Row>
          {achEnabled && !singlePaymentButton && (
            <PaymentMethodButton
              icon="/assets/bank-building-ACH-direct-debit.svg"
              name="ACH Direct Debit"
              isActive={paymentMethod === PAYMENT_METHODS.ACH_DIRECT_DEBIT}
              onClick={() =>
                onSelectPaymentMethod(PAYMENT_METHODS.ACH_DIRECT_DEBIT)
              }
            />
          )}

          {ccEnabled && (
            <PaymentMethodButton
              icon={ccButtonIcon}
              name={ccLabel}
              isActive={paymentMethod === PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD}
              onClick={() =>
                onSelectPaymentMethod(PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD)
              }
            />
          )}
          {checkEnabled && (
            <PaymentMethodButton
              icon="/assets/cheque-sign-icon.svg"
              name="Check"
              isActive={paymentMethod === PAYMENT_METHODS.CHECK}
              onClick={() => onSelectPaymentMethod(PAYMENT_METHODS.CHECK)}
            />
          )}
        </Row>
      )}
    </Grid>
  );
};
